<template>
  <v-layout >
    <v-navigation-drawer
    v-model="drawer"
    fixed 
    app
    dark
    fixed
    
  >

    <v-dialog
      v-model="connectOpen"
      width="400"
      >
      <ConnectContract v-if="connectOpen && !ConnectBasicAccount"  @connectClosed="connectOpen = false" :open="connectOpen">
      </ConnectContract>         
    </v-dialog>

    <v-list
      dense
      style="margin-top:200px;"
    >
      
      <template  v-for="(item, i) in sidebarContent">
        <v-layout
          v-if="item.heading"
          :key="i"
          row
          align-center

        >

          <v-flex xs6 class="text-xs-right">
            <v-btn small flat>edit</v-btn>
          </v-flex>
        </v-layout>
        <v-list-tile
          v-else
          :key="i"
          @click=""
          style="margin:20px;"
        > 

          <v-list-tile-content>
            <v-list-tile-title @click="goto(item.x)" class="grey--text title">
              {{ item.text }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>
  </v-navigation-drawer>
  <v-flex xs12>
        <v-tabs
      left
      color="cyan"
      dark
      icons-and-text
    >
    <!--   <v-flex xs2 d-flex>
          <v-select

          style="margin:11px !important; font-size:24px; "
            :items="['Smartpress', 'Scatter', 'Node.js']"
            v-model="codeTypeFormatted"
            

          ></v-select>
        </v-flex>-->
      <v-tabs-slider color="yellow"></v-tabs-slider>  

      
      <v-tab @click="currentDoc = 'token'" href="#tab-1">
        Node.js package
        <v-icon>toll</v-icon>
      </v-tab>

      <v-tab @click="currentDoc = 'nft'" href="#tab-2">
        API doumentation
        <v-icon>shield</v-icon>
      </v-tab>

<!--       <v-tab @click="currentDoc = 'database'" href="#tab-3">
        Database
        <v-icon>table_chart</v-icon>
      </v-tab> -->

      <v-tab-item
        v-for="i in 2"
        :key="i"
        :value="'tab-' + i"
      >
      </v-tab-item>
      
      <a href="https://www.youtube.com/embed/6kK6xj47jNs"> <v-btn color="green" style="position:absolute; right:200px; top:12px;">Explainer video</v-btn></a>
      <v-btn v-if="$router.history.current.path != '/p/docs'" @click="connectOpen = true" style="position:absolute; right:40px; top:12px;">Config file</v-btn>
    </v-tabs>



     <SmartpressToken :account="accountName" :key="currentDoc+codeType" v-if="currentDoc == 'token' && codeType == 'smartpress'"></SmartpressToken>

     <SmartpressNft :account="accountName" :key="currentDoc+codeType" v-if="currentDoc == 'nft' && codeType == 'smartpress'"></SmartpressNft>
 
     <NodeToken :account="accountName" :key="currentDoc+codeType" v-if="currentDoc == 'token' && codeType == 'node'"></NodeToken>
     <NodeNft :account="accountName" :key="currentDoc+codeType" v-if="currentDoc == 'nft' && codeType == 'node'"></NodeNft>
     <NodeDatabase :account="accountName" :key="currentDoc+codeType" v-if="currentDoc == 'database' && codeType == 'node'"></NodeDatabase>

     <ScatterToken :account="accountName" :key="currentDoc+codeType" v-if="currentDoc == 'token' && codeType == 'scatter'"></ScatterToken>
     <ScatterNft :account="accountName" :key="currentDoc+codeType" v-if="currentDoc == 'nft' && codeType == 'scatter'"></ScatterNft>
     <ScatterDatabase :account="accountName" :key="currentDoc+codeType" v-if="currentDoc == 'database' && codeType == 'scatter'"></ScatterDatabase>

    </v-flex>
  </v-layout>
</template>

<script>
  import { mapState } from 'vuex'
  import store from "@/store"
  import SmartpressToken from "./code/SmartpressToken"
  import SmartpressNft from "./code/SmartpressApi"
  import NodeToken from "./code/NodeToken"
  import NodeNft from "./code/NodeNft"
  import NodeDatabase from "./code/NodeDatabase"
  import ScatterToken from "./code/ScatterToken"
  import ScatterNft from "./code/ScatterNft"
  import ScatterDatabase from "./code/ScatterDatabase"
  import { component as VueCodeHighlight } from 'vue-code-highlight';
  import ConnectContract  from '../../components/Documentation/ConnectContract'

  export default {
    data () {
      return {
        connectOpen: false,
        codeType: 'smartpress',
        codeTypeFormatted: 'Smartpress',
        currentDoc: 'token',
        drawer:true,
        abc: '123',
        smartpressToken: [
          { x: 20, text: 'Get started' },
          { divider: true },
          { x: 600, text: 'Send asset' },
          { x: 1200, text: 'Create Account' },
          { x: 1800, text: 'Get balance' },
        ],
        smartpressNft: [
          { x: 20, text: 'Actions' },
          { divider: true },
          { x: 200, text: 'Send asset' },
          { x: 600, text: 'Create Account' },
          { x: 1000, text: 'Get balance' },
        ],
        nodeToken: [
          { x: 20, text: 'Actions' },
          { divider: true },
          { x: 2000, text: 'Create' },
          { x: 3050, text: 'Issue' },
          { x: 4050, text: 'Transfer' },
          { divider: true },
        ],
        nodeNft: [
          { x: 20, text: 'Actions' },
          { divider: true },
          { x: 2000, text: 'Create' },
          { x: 3050, text: 'Burn' },
          { x: 4050, text: 'Issue' },
          { x: 5050, text: 'Transfer' },
          { x: 6050, text: 'Transfer_id' },
          { divider: true },
        ],
        nodeDatabase: [
          { x: 20, text: 'Actions' },
          { divider: true },
          { x: 2000, text: 'Create' },
          { x: 3050, text: 'Issue' },
          { x: 4050, text: 'Transfer' },
          { divider: true },
        ],
        scatterToken: [
          { x: 20, text: 'Actions' },
          { divider: true },
          { x: 2000, text: 'Create' },
          { x: 3050, text: 'Issue' },
          { x: 4050, text: 'Transfer' },
          { divider: true },
        ],
        scatterNft: [
          { x: 20, text: 'Actions' },
          { divider: true },
          { x: 2000, text: 'Create' },
          { x: 3050, text: 'Burn' },
          { x: 4050, text: 'Issue' },
          { x: 5050, text: 'Transfer' },
          { x: 6050, text: 'Transfer_id' },
          { divider: true },
        ],
        scatterDatabase: [
          { x: 20, text: 'Actions' },
          { divider: true },
          { x: 2000, text: 'Create' },
          { x: 3050, text: 'Issue' },
          { x: 4050, text: 'Transfer' },
          { divider: true },
        ]
      }
    },
    components: {
      VueCodeHighlight,
      SmartpressToken,
      SmartpressNft,
      NodeToken,
      NodeNft,
      NodeDatabase,
      ScatterToken,
      ScatterNft,
      ScatterDatabase,
      ConnectContract
    },
    props: {
      keys: String
    },
    watch:  {
      currentDoc: function () {
        console.log('coom')
        this.$forceUpdate();
      },
      codeTypeFormatted: function () {
        if (this.codeTypeFormatted == 'Node.js') {
            this.codeType = 'node'
        } else if (this.codeTypeFormatted == 'Scatter') {
            this.codeType = 'scatter'
        } else if (this.codeTypeFormatted == 'Smartpress') {
            this.codeType = 'smartpress'
        }
        this.$forceUpdate();
      }   
    },
    computed: {
      sidebarContent: function  () {
        if (this.codeType == 'smartpress') {

          if (this.currentDoc == 'token')
            return this.smartpressToken
          else if (this.currentDoc == 'nft')
            return this.smartpressNft
          else if (this.currentDoc == 'database')
            return this.nodeDatabase
        } else if (this.codeType == 'node') {

          if (this.currentDoc == 'token')
            return this.nodeToken
          else if (this.currentDoc == 'nft')
            return this.nodeNft
          else if (this.currentDoc == 'database')
            return this.nodeDatabase
        } else if (this.codeType == 'scatter') {

          if (this.currentDoc == 'token')
            return this.scatterToken
          else if (this.currentDoc == 'nft')
            return this.scatterNft
          else if (this.currentDoc == 'database')
            return this.scatterDatabase
        }
      },
       ...mapState({
          myContracts: state => state.contractsDb.myContracts,
          // message: state => state.util.message,
      }),
      accountName: function () {
        if (this.myContracts.Items) {
          if (this.myContracts.Items[0] != null)
            return this.myContracts.Items[0].account_name.S
          else 
            return 'my_contract_name'
        } else {
          return null
        }
        
      }
    },
    created: function () {
      this.$store.dispatch('contractsDb/getMyContracts')

      if (this.$vuetify.breakpoint.smAndDown) {
        this.drawer = false
      }
    },
    methods: {
      goto(x) {
        this.$vuetify.goTo(x)
      }
    },
    destroyed: function () {
    }
  }
</script>

<style>
  .test {
    color:red;
  }
</style>
